module.exports = __webpack_public_path__ + "img/eye.c96c957a.svg";